import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { FormField } from '../../entities/form.entity';
import { EMAIL_MAX_LENGTH, URL_MAX_LENGTH } from '../../entities/app.entity';
import { Subject, debounceTime, takeUntil } from 'rxjs';

@Component({
  selector: 'app-field-input-text',
  templateUrl: './field-input-text.component.html',
  styleUrls: ['./field-input-text.component.scss'],
})
export class FieldInputTextComponent implements OnInit, OnDestroy {
  @Input() field!: FormField;
  @Input() disabled: boolean = false;
  @Output() onFieldChange = new EventEmitter<{
    fieldId: string;
    isValid: boolean;
    value: any;
  }>();
  isValid!: boolean;
  errorMessage: string = '';
  readonly emailMaxLength = EMAIL_MAX_LENGTH;
  readonly urlMaxLength = URL_MAX_LENGTH;
  private destroy$ = new Subject<void>();
  private fieldChangeSubject = new Subject<void>();
  @ViewChild('inputField') inputField!: ElementRef;

  ngOnInit() {
    this.fieldChangeSubject
      .pipe(debounceTime(1000), takeUntil(this.destroy$))
      .subscribe(() => {
        this.emitFieldChange();
      });

    // Add event listener for autocomplete
    if (this.inputField) {
      this.inputField.nativeElement.addEventListener('change', (event: any) => {
        this.handleAutocomplete(event);
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  handleTextareaChange(event: any) {
    const newValue = event.target.value;
    this.field.value = newValue;
    this.fieldChangeSubject.next();
  }

  onPhoneChange(value: any) {
    this.field.value = value;
    this.fieldChangeSubject.next();
  }

  getPattern(textDataType: string): string | null {
    switch (textDataType) {
      case 'email':
        return '^[a-zA-Z0-9_%+-]+(\.[a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$';
      case 'phone-number':
        return '^\\+?[0-9]{10,13}$';
      case 'url':
        return 'https?://.+';
      case 'numeric':
        return '\\d+';
      default:
        return null;
    }
  }

  getIconName(textDataType: string): string {
    switch (textDataType) {
      case 'email':
        return 'at-sign';
      case 'phone-number':
        return 'phone';
      case 'url':
        return 'link';
      default:
        return '';
    }
  }
  emitFieldChange(): void {
    this.isValid = this.validateField(this.field.value);
    const type = this.field.metadata.textDataType || '';
    this.errorMessage = this.isValid ? '' : this.getErrorMessage(type);
    this.onFieldChange.emit({
      fieldId: this.field.fieldId,
      isValid: this.isValid,
      value: this.field.value,
    });
  }

  getErrorMessage(textDataType: string): string {
    switch (textDataType) {
      case 'email':
        return 'Please enter a valid email address.';
      case 'phone-number':
        return 'Please enter a valid phone number.';
      case 'url':
        return 'Please enter a valid URL.';
      case 'numeric':
        return 'Please enter numeric values only.';
      default:
        return 'Invalid input.';
    }
  }

  validateField(value: string | null): boolean {

    if (!value && (this.isValid || this.field.isValid)) return true;

    if (!value) return false;

    const dataType = this.field.metadata.textDataType;
    if (!dataType) return false;
    const pattern = this.getPattern(dataType);

    if (!pattern) return true;

    const regex = new RegExp(pattern);
    return regex.test(value);
  }

  getMask(textDataType: any): string | null {
    switch (textDataType) {
      case 'phone-number':
        return '000-000-0000';
      default:
        return null;
    }
  }

  handleAutocomplete(event: any) {
    const newValue = event.target.value;
    this.field.value = newValue;
    this.emitFieldChange();
  }

  handleBlur(event: any) {
    this.emitFieldChange();
  }
}
